module.exports = __webpack_public_path__ + "static/media/logo.8ed9ab19.png";